export function getErrorStatus(error) {
  let customMessage = ''
  let status = 0
  let errors = []
  if (error.response) {
    // 要求がなされたとサーバがステータスコードで応答した
    status = error.response.status
    errors = error.response.data.errors
    if (error.response.data && error.response.data.message) {
      customMessage = error.response.data.message
    }
  } else if (error.request) {
    // 要求がなされたが、応答が受信されなかった
    status = 500
  } else {
    // トリガーしたリクエストの設定に何かしらのエラーがある
    status = 422
  }
  return {
    customMessage: customMessage,
    errors: errors,
    status: status
  }
}

export function getApiStatusEmpty() {
  return {
    status: 0,
    customMessage: '',
    errors: []
  }
}
export function getApiStatusSuccess() {
  return {
    status: 200,
    customMessage: '',
    errors: []
  }
}

// セレクトフォーム用に選択肢を作成
export function getSelectionsByObject(list, showAll) {
  if (!list) {
    list = {}
  }
  const ArrangedList = Object.keys(list).map((key) => {
    return { text: list[key], value: Number(key) }
  })
  if (showAll) {
    ArrangedList.unshift({ text: '全て', value: 'all' })
  }
  return ArrangedList
}

export function getSelectionsByArray(list, showAll) {
  if (!list) {
    list = {}
  }
  const ArrangedList = list.map((e) => {
    return { text: e.name, value: Number(e.id) }
  })
  if (showAll) {
    ArrangedList.unshift({ text: '全て', value: 'all' })
  }
  return ArrangedList
}

// チェックボックス用に選択肢を作成
export function getSelectionsForCheckList(list) {
  if (!list) {
    list = {}
  }
  const ArrangedList = Object.keys(list).map((key) => {
    return { text: list[key], value: key }
  })
  return ArrangedList
}

export function isAuth() {
  if (location.href.indexOf('admin') >= 0) {
    return true
  }
  return false
}

export default {
  getErrorStatus,
  getApiStatusEmpty,
  getApiStatusSuccess,
  getSelectionsByObject,
  getSelectionsByArray,
  isAuth
}
